import { render, staticRenderFns } from "./TestTagManager.vue?vue&type=template&id=5d26bc1a&"
import script from "./TestTagManager.vue?vue&type=script&lang=js&"
export * from "./TestTagManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports